import { withRouter } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  resetPassword,
  resetPasswordUser,
  resetPasswordVerifyUser,
  resetPasswordConfirm,
  cancelReset,
} from '../../redux/services/reset-password-service/reset-password-service';
import { bindActionCreators } from 'redux';
import ResetPasswordForm from '../../components/reset-password/reset-password';
import ResetPasswordConfirmForm from '../../components/reset-password/reset-password-confirm';
import ProgressIndicator from '../../components/common/progress-indicator/progress-indicator';

export class ResetPasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      username: '',
    };
  }

  componentDidMount = () => {
    this.props.cancelReset();
  };

  handleSubmit = values => {
    this.setState({ username: values.username });
    this.props.resetPasswordVerifyUser(values.username);
  };

  handleResetConfirm = values => {
    if (values.newPassword && values.passwordConfirm) {
      let payload = {
        selectedEmailId: this.state.username,
        newPassword: values.passwordConfirm,
        token: values.code,
      };
      this.props.resetPasswordUser(payload);
      // this.props.resetPasswordConfirm(
      //   this.state.username,
      //   values.code,
      //   values.passwordConfirm,
      // );
    }
  };

  handleBack = e => {
    e.preventDefault();
    this.props.history.push('/login');
  };

  render() {
    console.log(this.props.isLoading);
    return this.props.isLoading ? (
      <div>
        <ProgressIndicator />
      </div>
    ) : (
      <React.Fragment>
        {this.props.reset === undefined && (
          <div>
            <ResetPasswordForm
              errors={this.props.error}
              inProgress={this.props.isLoading}
              onSubmit={this.handleSubmit.bind(this)}
            />
          </div>
        )}{' '}
        {this.props.reset !== undefined && this.props.reset && (
          <div>
            <ResetPasswordConfirmForm
              errors={this.props.error}
              inProgress={this.props.isLoading}
              onSubmit={this.handleResetConfirm.bind(this)}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({ ...state.resetPassReducer });

const mapDispatchToProps = dispatch => ({
  resetPassword: bindActionCreators(resetPassword, dispatch),
  resetPasswordUser: bindActionCreators(resetPasswordUser, dispatch),
  resetPasswordVerifyUser: bindActionCreators(
    resetPasswordVerifyUser,
    dispatch,
  ),
  resetPasswordConfirm: bindActionCreators(resetPasswordConfirm, dispatch),
  cancelReset: bindActionCreators(cancelReset, dispatch),
});

ResetPasswordContainer.propTypes = {
  error: PropTypes.object,
  resetPasswordUser: PropTypes.func,
  resetPasswordVerifyUser: PropTypes.func,
  resetPasswordConfirm: PropTypes.func,
  resetPassword: PropTypes.func,
  cancelReset: PropTypes.func,
  reset: PropTypes.bool,
  history: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer),
);
